// Setting Outage Banner
const SET_OUTAGE_BANNER = 'SET_OUTAGE_BANNER';
const CLOSE_OUTAGE_BANNER = 'CLOSE_OUTAGE_BANNER';

export {
  SET_OUTAGE_BANNER,
  CLOSE_OUTAGE_BANNER,
};
